import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {Empty, Typography} from 'antd'
import {Button} from '@/components'
import {hasPermissions} from '@/stores/auth/services/utils'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import styles from './styles.scss'
import { ADD_FIRST_DOMAIN } from '@/constants/playwright-ids'

type Props = {
    onClick: () => void
}

export const NoDomains: React.FC<Props> = ({onClick}) => {
    const { t } = useTranslation()
    return (
        <div className={styles.container}>
            <br/><br/>
            <Typography.Title level={5}>
                {t('NoDomains.hereWillBeTheList')}
            </Typography.Title>
            <Empty description={<Typography.Text type={'secondary'}>
                <Trans
                    i18nKey='NoDomains.textWithExplanationOfDomain'
                    components={{ br: <br/> }}
                />
            </Typography.Text>}/>
            {
                hasPermissions([PermissionsMap.payment_methods.full]) ?
                <Button
                    onClick={onClick}
                    className={styles.btn}
                    type={'primary'}
                    data-test-id={ADD_FIRST_DOMAIN}
                >
                    + {t('NoDomains.addNewDomain')}
                </Button> : null
            }
        </div>
    )
}
